import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const BurgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [toursOpen, setToursOpen] = useState(false); // ✅ submenu toggle
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <button
        onClick={toggleMenu}
        className={`burger-button ${isOpen ? "burger-button-open" : ""}`}
      >
        {isOpen ? "→" : "☰"}
      </button>

      {isOpen && (
        <div ref={menuRef} className="burger-menu">
          <Link to="/" onClick={toggleMenu}>
            Home
          </Link>

          {/* ✅ Cab Tours with dropdown */}
          <div className="submenu">
            <button
              className="submenu-toggle"
              onClick={() => setToursOpen(!toursOpen)}
            >
              Cab Tours {toursOpen ? "▲" : "▼"}
            </button>
            {toursOpen && (
              <div className="submenu-links">
                <Link to="/cab-tours" onClick={toggleMenu}>
                  All Tours
                </Link>
                <Link to="/cab-tours/murals-tour" onClick={toggleMenu}>
                  Belfast Murals Tour
                </Link>
                <Link to="/cab-tours/belfast-political" onClick={toggleMenu}>
                  Belfast Political Tour
                </Link>
                <Link to="/cab-tours/giants-causeway" onClick={toggleMenu}>
                  Giant’s Causeway Tour
                </Link>
                <Link to="/cab-tours/dark-hedges" onClick={toggleMenu}>
                  Dark Hedges & Glens
                </Link>
              </div>
            )}
          </div>

          <Link to="/tour-planning-tool" onClick={toggleMenu}>
            Tour Planner
          </Link>
          <Link to="/blog" onClick={toggleMenu}>
            Blog
          </Link>
          <Link to="/FAQs" onClick={toggleMenu}>
            FAQs
          </Link>
          <Link to="/contact" onClick={toggleMenu}>
            Contact Us
          </Link>
        </div>
      )}
    </div>
  );
};

export default BurgerMenu;
